import { SolicitudTraspaso } from './solicitudTraspaso';
import { Usuario } from './usuario';

export class HistorialFirmaTraspaso {
    constructor(
        public id:                          number,
        public fechaCreacion:               string,
        public fechaFirmaTraspaso:          string,
        public horaFirmaTraspaso:           string,

        // Relaciones
        public SolicitudTraspasoId:         number,
        public UsuarioId:                   number,
    ){}

    solicitudTraspaso:  SolicitudTraspaso;
    usuario:            Usuario;
    
    // Fechas
    fechaCreacionFormato:       string;
    fechaCreacionDate:          Date;
    fechaFirmaTraspasoFormato:  string;
    fechaFirmaTraspasoDate:     Date;
}